//export const API_URL = "https://checkcar.site/backend/api";
// export const API_URL = `http://backend.test/api`;
export const API_URL = `https://checkcar.blog/api`;
// export const API_URL = `http://localhost:8000/api`;
